module.exports = __webpack_public_path__ + "static/2889b152-497e-4ea3-a90d-02854d136a8d-51f998c5a6386f9a21989122f4329b1c.ttf";